import React from 'react';
import LoginPage from './LoginPage';
import PrivateRoute from './PrivateRoute';

// Route-level code splitting: everything except the login screen and the
// routing wrapper is loaded on demand, so the initial bundle (and the
// heavy per-page deps like react-quill/jspdf/react-dropzone) don't block
// the first paint for every visit.
const Dashboard = React.lazy(() => import('./Dashboard'));
const OrdersPage = React.lazy(() => import('./OrdersPage'));
const ProductsPage = React.lazy(() => import('./ProductsPage'));
const AdminsPage = React.lazy(() => import('./AdminsPage'));
const PrestatairesPage = React.lazy(() => import('./PrestatairesPage'));
const SingleOrderPage = React.lazy(() => import('./SingleOrderPage'));
const SingleProductPage = React.lazy(() => import('./SingleProductPage'));
const CategoriesPage = React.lazy(() => import('./CategoriesPage'));
const HeroImagesPage = React.lazy(() => import('./HeroImagesPage'));
const PlatformReviewsPage = React.lazy(() => import('./PlatformReviewsPage'));
const OffersPage = React.lazy(() => import('./OffersPage'));
const CreateProductPage = React.lazy(() => import('./CreateProductPage'));
const EditProductPage = React.lazy(() => import('./EditProductPage'));
const NotFoundPage = React.lazy(() => import('./NotFoundPage'));

export {
  Dashboard,
  LoginPage,
  PrivateRoute,
  OrdersPage,
  ProductsPage,
  AdminsPage,
  PrestatairesPage,
  SingleOrderPage,
  SingleProductPage,
  CategoriesPage,
  HeroImagesPage,
  PlatformReviewsPage,
  OffersPage,
  CreateProductPage,
  EditProductPage,
  NotFoundPage,
};
